'use client';

import * as DS from '@aurorasolar/ds';
import Link from 'next/link';

import { privacyPolicyUrl, useLegalPath } from '@/app/components';

export const LegalLinks = () => {
  const legalPathPrefix = useLegalPath();

  return (
    <DS.Flex
      alignItems="center"
      color="uiHelperCopy"
      flexDirection="row"
      gap={1}
      text={{ _: 'body12', xl: 'body16' }}
      w="auto"
    >
      <DS.IconInfoCircle size={{ _: 4, xl: 5 }} />
      <Link href={`${legalPathPrefix}/terms`} style={{ color: 'inherit', textDecoration: 'underline' }}>
        Terms &amp; Conditions
      </Link>{' '}
      and{' '}
      <Link href={privacyPolicyUrl} style={{ color: 'inherit', textDecoration: 'underline' }}>
        Privacy Policy
      </Link>
    </DS.Flex>
  );
};
